module.exports = __webpack_public_path__ + "static/wellcome-97c7f44739a52354c593bc8f049014ee.png";